import styled from 'styled-components';

export const Trophy = styled.img`
  cursor: pointer;
  &:hover {
    opacity: 0.9;
    transform: scale(1.1);
  }
`;
